import { render } from "./YoutubeView.vue?vue&type=template&id=59b4101a"
import script from "./YoutubeView.vue?vue&type=script&lang=js"
export * from "./YoutubeView.vue?vue&type=script&lang=js"

import "./YoutubeView.vue?vue&type=style&index=0&id=59b4101a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__